/* La mappa della linea (GI-226): sostegni, campate, traiettoria e anomalie
 * in una risposta sola, gia' in WGS84. Il fronte la proietta su una tela SVG
 * senza chiedere tessere a nessuno (ADR-002). */
import { get } from './api'

/** Latitudine e longitudine, in quest'ordine: e' la convenzione del servizio. */
export type MapPoint = [number, number]

export interface MapElement {
  element_id: string
  external_element_id: number
  element_type: string
  latitude: number | null
  longitude: number | null
  /** `covered`, `declared` oppure `gap`, come nella copertura. */
  status: string
  frames: number
  reviewed_frames: number
  candidate_frames: number
  findings: number
  /** Il livello piu' grave fra le anomalie scritte; nessuno se non ce ne sono. */
  worst_level: number | null
}

export interface MapSpan {
  ordinal: number
  length_m: number
  points: MapPoint[]
}

export interface MapMark {
  detection_id: string
  element_id: string | null
  code: string
  source: string
  level: number
  final_level: number | null
  decision: string | null
  confirmed: boolean
  latitude: number
  longitude: number
  measured_distance_m: number | null
  minimum_distance_m: number | null
}

export interface MapPhoto {
  photo_id: string
  filename: string
  camera: string | null
  latitude: number
  longitude: number
}

export interface Basemap {
  id: string
  url: string
  attribution: string
  max_zoom: number
}

export interface LineMap {
  inspection_id: string
  elements: MapElement[]
  spans: MapSpan[]
  trajectory: MapPoint[]
  trajectory_points: number
  marks: MapMark[]
  photos: MapPhoto[]
  photos_total: number
  basemaps: Basemap[]
}

export function readLineMap(inspectionId: string): Promise<LineMap> {
  return get<LineMap>(`/inspections/${encodeURIComponent(inspectionId)}/line-map`)
}
